import 'datatables.net';

export default {
    init() {
        // JavaScript to be fired on the home page
        const tableDataElement = document.querySelector("#resources-table-json");
        const tableData = JSON.parse(tableDataElement.innerHTML);

        let table = $("#resources-table").DataTable({
            data: tableData,
            info: false,
            lengthChange: false,
            pageLength: 5,
            columns: [
                {
                    data: null,
                    render: function(data, type, row) {
                        return "<i class='" + row.faClass + " resources-table__file-svg'></i><span class='resources-table__file-name'>" + data.fileTitle + "</span>";
                    },
                },
                {data: 'termName'},
                {data: 'date'},
                {
                    data: null,
                    sortable: false,
                    className: 'text-right',
                    render: function(data, type, row) {
                        let buttonText = row.filetype === 'link' ? 'Go to link' : 'Download';
                        return '<a class="button resources-table__button square-button--purple" target="_blank" href="' + row.permalink + '" download>' + buttonText + '</a>'
                    },
                },
                {data: 'termId', visible: false, searchable: true},
                {data: 'uploadDate', visible: false},
                {data: 'faClass', 'visible': false},
            ],
            "language": {
                searchPlaceholder: "Enter search query",
                paginate: {
                    "previous": "<span class='small-chevron--left'></span>",
                    "next": "<span class='small-chevron--right'></span>",
                },
            },
        });

        const $typeSelect = $("#resource-filter--filetype");

        $("#resource-filters__reset").click(function (e) {
            e.preventDefault();

            $typeSelect.val($("option:first", $typeSelect).val());
            $typeSelect.trigger("change");
        });

        $("#resources-table_filter").appendTo("#resource-filters");

        $typeSelect.on('change', function () {
            let val = $(":selected", $(this)).val();
            table.columns(4).search(val);
            table.draw();
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/resources.js